const Parking = {

    // FIELDS    
    "premise": 'Premise',
    "parking_name": 'Parking Name',
    "zone": 'Zone',
    "level": 'Level',
    "unit": 'Unit',
    "parking_type": 'Parking Type',
    "resident": 'Resident',
    "visitor": 'Visitor',
    "cars_allowed": 'Cars Allowed',
    "two_wheeler_allowed": 'Two Wheeler Allowed',
    "heavy_vehicle_allowed": 'Heavy Vehicle Allowed',
    "remark": 'Remark',
    "search": 'Search',

    // PAGE HEADER
    "parking": 'Parking',

    // TABLE HEADERS
    "table_premise": 'PREMISE',
    "table_name": 'PARKING NAME',
    "table_unit": 'UNIT HIERARCHY',
    "table_type": 'PARKING TYPE',
    "table_cars_allowed": 'CARS ALLOWED',
    "table_two_wheeler_allowed": 'TWO WHEELER ALLOWED',
    "table_heavy_vehicle_allowed": 'HEAVY VEHICLE ALLOWED',
    "table_remark": 'REMARK',

    // ERROR
    "error_premise": 'Select Premise',
    "error_parking_name": 'Enter Parking Name',
    "error_zone": 'Select Zone',
    "error_level": 'Select Level',
    "error_unit": 'Select Unit',
    "error_parking_type": 'Select Parking Type',
    "error_cars_allowed": 'Enter Cars Allowed',
    "error_two_wheeler_allowed": 'Enter Two Wheeler Allowed',
    "error_heavy_vehicle": 'Enter Heavy Vehicle Allowed',
    "error_min": 'Value must be 0 or greater',
    "warn_select_premise": "Please select a premise first",
};

export default Parking;